import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, CardBody, CardHeader, Row } from 'reactstrap';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';

import MapSimple from '../../../../Components/General/Map/MapSimple';


import { getEstablishment } from '../../../../slices/thunks';
import CardWithError from '../../../../Components/Common/CardWithError';
import CardWithoutData from '../../../../Components/Common/CardWithoutData';

const EstablishmentInfo = ({ id }) => {
    const dispatch = useDispatch();

    if (id === 'all') return null

    const selectorEstablishments = createSelector(
        state => state.Establishments,
        establishment => ({
            data: establishment.itemEstablishmentDetail,
            isLoading: establishment.isLoading,
            isSuccess: establishment.isSuccess,
            isError: establishment.isError,
        })
    );

    const { data, isLoading, isSuccess, isError } = useSelector(selectorEstablishments);

    useEffect(() => {
        if (id != 'all') {
            dispatch(getEstablishment(id));
        }
    }, []);


    return (

        <React.Fragment>
            <Row className='m-0 p-0'>
                {isLoading ? (
                    <OPlaceholder />
                ) : isError ? (
                    <CardWithError title={'Establecimiento'} />
                ) : (
                    isSuccess && data ? (

                        <React.Fragment>
                            <Card className='p-0'>
                                <CardHeader className='p-2'>
                                    <h3 className='p-0 m-0 text-uppercase'>{data.name}</h3>
                                </CardHeader>
                                <CardBody className='p-2'>
                                    <ul className="list-unstyled mb-0 vstack gap-1">
                                        <li>
                                            <span className="text-muted">Etapa</span>
                                            <span className='fw-semibold float-end'>{data.establishment_stage?.name}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Correo</span>
                                            <span className='fw-semibold float-end'>{data.email}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Código SIEP</span>
                                            <span className='fw-semibold float-end'>{data.code_siep}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Código RETC</span>
                                            <span className='fw-semibold float-end'>{data.code_retc}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Código SMA</span>
                                            <span className='fw-semibold float-end'>{data.code_sma}</span>
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>

                            <Card className='p-0'>
                                <CardHeader className='p-2'>
                                    <h5 className="card-title mb-0">
                                        <i className="ri-earth-line align-middle me-1 text-muted"></i>Ubicación
                                    </h5>
                                </CardHeader>
                                <CardBody className='p-2'>
                                    <ul className="list-unstyled mb-0 vstack gap-1">
                                        <li>
                                            <span className="text-muted">Región</span>
                                            <span className='fw-semibold float-end'>Los Lagos</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Comuna</span>
                                            <span className='fw-semibold float-end'>{data?.commune?.name}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Barrio</span>
                                            <span className='fw-semibold float-end'>{data?.sanitary_vicinity?.name}</span>
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>

                            <Card className='p-0'>
                                <CardHeader className='p-2'>
                                    <h5 className="card-title mb-0">
                                        <i className={`${Icons.pin} align-middle me-1 text-muted`}></i>Coordenadas UTM
                                    </h5>
                                </CardHeader>
                                <CardBody className='p-2'>
                                    <ul className="list-unstyled mb-0 vstack gap-1">
                                        <li>
                                            <span className="text-muted">Este</span>
                                            <span className='fw-semibold float-end'>{data.east}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Norte</span>
                                            <span className='fw-semibold float-end'>{data.north}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Huso</span>
                                            <span className='fw-semibold float-end'>{data.zone}</span>
                                        </li>
                                        <li>
                                            <span className="text-muted">Datum</span>
                                            <span className='fw-semibold float-end'>{data.datum}</span>
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </React.Fragment>
                    ) : (
                        <CardWithoutData title={'Establecimiento'} />
                    )
                )}

                {isLoading ? (
                    <OPlaceholder />
                ) : isError ? (
                    <CardWithError title={'Ubicación'} />
                ) : (
                    isSuccess && data ? (
                        <React.Fragment>
                            <MapSimple
                                latitude={data.latitude}
                                longitude={data.longitude}
                                zoom={16}
                                mapStyle="Streets"
                                markerInfo={data.name}
                            />
                        </React.Fragment>
                    ) : (
                        <CardWithoutData title={'Ubicación'} />
                    )
                )}



            </Row>

        </React.Fragment>
    );
};

export default EstablishmentInfo;


